"use client";

import { legacyIconCls } from "@faire/web/slate/utils/tracking";
import React from "react";

import { createSVGIcon } from "../util";

/**
 * @deprecated use Filter from foundation/Filter
 * @trackcomponent
 * @optimized using svgo:^3.0.2
 */
export const SmallFilter = createSVGIcon(
  <path
    d="M1 2.5h12M1 7.5h12M10.5 9V6M3.5 4V1"
    stroke="currentColor"
    strokeLinecap="square"
  />,
  "Small Filter",
  { viewBox: "0 0 14 10", className: legacyIconCls() }
);
